/* Desayunos del Cielo · Blog v2: filtros, barra de progreso, carruseles, reel en vista, compartir, barra CTA. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function track(name, label) {
    try { if (window.gtag) window.gtag('event', name, { label: label || '' }); } catch (e) {}
  }

  function initFilters(root) {
    var chips = root.querySelectorAll('[data-ddcb-filter]');
    if (!chips.length) return;
    var items = root.querySelectorAll('[data-ddcb-cat]');
    var empty = root.querySelector('[data-ddcb-empty]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-ddcb-filter');
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var visible = 0;
        items.forEach(function (it) {
          var show = f === '*' || it.getAttribute('data-ddcb-cat') === f;
          it.hidden = !show;
          if (show) visible++;
        });
        if (empty) empty.hidden = visible > 0;
        track('blog_filter', f);
      });
    });
  }

  function initProgress() {
    var bar = document.querySelector('[data-ddcb-progress]');
    var body = document.querySelector('.ddcb-prose');
    var ctabar = document.querySelector('[data-ddcb-ctabar]');
    var hero = document.querySelector('.ddcb-ahero');
    if (!bar && !ctabar) return;
    var ticking = false;
    var marks = { 25: false, 50: false, 75: false, 100: false };
    function update() {
      ticking = false;
      if (bar && body) {
        var r = body.getBoundingClientRect();
        var total = r.height - window.innerHeight * 0.5;
        var p = Math.min(1, Math.max(0, (-r.top + window.innerHeight * 0.25) / (total || 1)));
        bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
        Object.keys(marks).forEach(function (k) {
          if (!marks[k] && p * 100 >= +k) { marks[k] = true; track('blog_read_' + k); }
        });
      }
      if (ctabar && hero) {
        ctabar.classList.toggle('is-visible', hero.getBoundingClientRect().bottom < 0);
      }
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initRail(rail) {
    var trackEl = rail.querySelector('[data-ddcb-rail-track]');
    var prev = rail.querySelector('[data-ddcb-prev]');
    var next = rail.querySelector('[data-ddcb-next]');
    if (!trackEl || !prev || !next) return;
    function state() {
      prev.disabled = trackEl.scrollLeft < 8;
      next.disabled = trackEl.scrollLeft + trackEl.clientWidth >= trackEl.scrollWidth - 8;
    }
    if (window.matchMedia('(hover: hover)').matches) { prev.hidden = false; next.hidden = false; }
    function step(dir) {
      var item = trackEl.querySelector('li');
      var w = item ? item.getBoundingClientRect().width + 14 : 240;
      trackEl.scrollBy({ left: dir * w * 2, behavior: reduce ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    trackEl.addEventListener('scroll', state, { passive: true });
    state();
  }

  function initGallery(g) {
    var count = g.parentElement.querySelector('[data-ddcb-gallery-count]');
    var slides = g.children;
    if (!count || !slides.length) return;
    g.addEventListener('scroll', function () {
      var w = slides[0].getBoundingClientRect().width + 10;
      var i = Math.min(slides.length, Math.round(g.scrollLeft / w) + 1);
      count.textContent = i + ' / ' + slides.length;
    }, { passive: true });
  }

  function initVideos() {
    var vids = document.querySelectorAll('video[data-ddcb-autoplay]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.6 && !reduce) {
          if (!v.src && v.dataset.src) { v.src = v.dataset.src; v.muted = true; v.load(); }
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: [0, 0.6] });
    vids.forEach(function (v) { io.observe(v); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) vids.forEach(function (v) { v.pause(); });
    });
  }

  function initShare() {
    document.querySelectorAll('[data-ddcb-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var data = { title: btn.getAttribute('data-title') || document.title, url: location.href.split('?')[0] };
        track('blog_share');
        if (navigator.share) { navigator.share(data).catch(function () {}); return; }
        var wa = 'https://wa.me/?text=' + encodeURIComponent(data.title + ' ' + data.url);
        window.open(wa, '_blank', 'noopener');
      });
    });
  }

  function wrapTables() {
    document.querySelectorAll('.ddcb-prose table').forEach(function (t) {
      if (t.parentElement.classList.contains('ddcb-table-wrap')) return;
      var w = document.createElement('div');
      w.className = 'ddcb-table-wrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
      var heads = [].map.call(t.querySelectorAll('thead th'), function (th) { return th.textContent.trim(); });
      t.querySelectorAll('tbody tr').forEach(function (tr) {
        [].forEach.call(tr.children, function (td, i) { if (heads[i]) td.setAttribute('data-label', heads[i]); });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ddcb-index]').forEach(initFilters);
    document.querySelectorAll('[data-ddcb-rail]').forEach(initRail);
    document.querySelectorAll('[data-ddcb-gallery]').forEach(initGallery);
    wrapTables();
    initProgress();
    initVideos();
    initShare();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
